import "./src/styles/global.css";
import React from "react";
import AppChrome from "./src/components/AppChrome";
import { trackPageView } from "./src/services/analyticsService";

const gaId = "G-CMM62BSLSP"; // or inject from env

// Initialize GA once on first load
export const onClientEntry = () => {
  if (!gaId) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", gaId);
};

// Track SPA route changes
export const onRouteUpdate = ({ location }) => {
  trackPageView(location.pathname, document?.title);
};

export const wrapRootElement = ({ element }) => (
  <AppChrome>{element}</AppChrome>
);
